import { useState } from "react"
import { useNavigate } from "react-router"
import styles from "./group-detail-page.module.css"

type TabType = "posts" | "members" | "about"

// SVG Icons
const BackIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M19 12H5M12 19l-7-7 7-7"/>
  </svg>
)

const MoreIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="1"/>
    <circle cx="12" cy="5" r="1"/>
    <circle cx="12" cy="19" r="1"/>
  </svg>
)

const ShareIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="18" cy="5" r="3"/>
    <circle cx="6" cy="12" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98"/>
  </svg>
)

const GroupIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
  </svg>
)

const ImageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <polyline points="21 15 16 10 5 21"/>
  </svg>
)

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
)

const MessageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
)

const HeartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
  </svg>
)

const UserAddIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
    <circle cx="8.5" cy="7" r="4"/>
    <line x1="20" y1="8" x2="20" y2="14"/>
    <line x1="23" y1="11" x2="17" y2="11"/>
  </svg>
)

const SettingIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/>
  </svg>
)

const EmptyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M19 11H5M12 17V11"/>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
  </svg>
)

export default function GroupDetailPage() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<TabType>("posts")
  const [isJoined, setIsJoined] = useState(false)

  // Mock data
  const groupData = {
    id: "1",
    name: "蓝血精英创业者联盟",
    description: "汇聚名校精英创业者，打造高端创业交流平台，分享创业经验与资源对接",
    coverUrl: "",
    avatar: "",
    memberCount: 2847,
    postCount: 156,
    isPublic: true,
  }

  const mockPosts = [
    {
      id: "1",
      title: "如何在创业初期找到合适的联合创始人",
      thumbnail: "",
      author: "李明",
      viewCount: 1256,
      likeCount: 89,
      commentCount: 23,
      createdAt: "2小时前",
    },
    {
      id: "2",
      title: "从0到1：我的第一个100万营收之路",
      thumbnail: "",
      author: "王芳",
      viewCount: 2341,
      likeCount: 156,
      commentCount: 45,
      createdAt: "5小时前",
    },
    {
      id: "3",
      title: "创业者必读：融资谈判的十大技巧",
      thumbnail: "",
      author: "张伟",
      viewCount: 892,
      likeCount: 67,
      commentCount: 18,
      createdAt: "昨天",
    },
  ]

  const handleJoin = () => {
    setIsJoined(!isJoined)
  }

  const handleShare = () => {
    // Share logic
  }

  return (
    <div className={styles.page}>
      {/* Header */}
      <div className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <BackIcon />
        </button>
        <div className={styles.headerTitle}>社群详情</div>
        <div className={styles.headerActions}>
          <button className={styles.actionBtn} onClick={handleShare}>
            <ShareIcon />
          </button>
          <button className={styles.actionBtn}>
            <MoreIcon />
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <div className={styles.hero}>
        <div className={styles.heroBg} />
        <div className={styles.heroContent}>
          {/* Cover */}
          <div className={styles.coverWrapper}>
            <div className={styles.cover}>
              {groupData.coverUrl ? (
                <img src={groupData.coverUrl} alt={groupData.name} />
              ) : (
                <div className={styles.coverPlaceholder}>
                  <GroupIcon />
                </div>
              )}
            </div>
          </div>

          {/* Group Info */}
          <div className={styles.groupInfo}>
            <div className={styles.avatarWrapper}>
              <div className={styles.groupAvatar}>
                <GroupIcon />
              </div>
              <span className={styles.memberCount}>{groupData.memberCount}</span>
            </div>
            <div className={styles.groupMeta}>
              <h1 className={styles.groupName}>{groupData.name}</h1>
              <p className={styles.groupDesc}>{groupData.description}</p>
              <div className={styles.groupStats}>
                <div className={styles.statItem}>
                  <EyeIcon />
                  <span className={styles.statValue}>{groupData.postCount}</span>
                  <span>帖子</span>
                </div>
                <div className={styles.statItem}>
                  <MessageIcon />
                  <span className={styles.statValue}>{groupData.memberCount}</span>
                  <span>成员</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className={styles.actionBtns}>
        {isJoined ? (
          <>
            <button className={styles.actionBtnMain}>
              <MessageIcon />
              <span>发帖子</span>
            </button>
            <button className={styles.actionBtnSecondary} onClick={handleJoin}>
              <UserAddIcon />
              <span>已加入</span>
            </button>
          </>
        ) : (
          <>
            <button className={styles.actionBtnMain} onClick={handleJoin}>
              <UserAddIcon />
              <span>加入社群</span>
            </button>
            <button className={styles.actionBtnSecondary}>
              <SettingIcon />
              <span>设置</span>
            </button>
          </>
        )}
      </div>

      {/* Tabs */}
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === "posts" ? styles.activeTab : ""}`}
          onClick={() => setActiveTab("posts")}
        >
          帖子
        </button>
        <button
          className={`${styles.tab} ${activeTab === "members" ? styles.activeTab : ""}`}
          onClick={() => setActiveTab("members")}
        >
          成员
        </button>
        <button
          className={`${styles.tab} ${activeTab === "about" ? styles.activeTab : ""}`}
          onClick={() => setActiveTab("about")}
        >
          关于
        </button>
      </div>

      {/* Content */}
      <div className={styles.content}>
        {activeTab === "posts" && (
          <div className={styles.postList}>
            {mockPosts.length > 0 ? (
              mockPosts.map((post) => (
                <div key={post.id} className={styles.postItem}>
                  <div className={styles.postThumb}>
                    {post.thumbnail ? (
                      <img src={post.thumbnail} alt={post.title} />
                    ) : (
                      <div className={styles.postThumbPlaceholder}>
                        <ImageIcon />
                      </div>
                    )}
                  </div>
                  <div className={styles.postMain}>
                    <h3 className={styles.postTitle}>{post.title}</h3>
                    <div className={styles.postMeta}>
                      <span>{post.author}</span>
                      <span>·</span>
                      <span>{post.createdAt}</span>
                      <span>·</span>
                      <span>
                        <EyeIcon /> {post.viewCount}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.emptyState}>
                <div className={styles.emptyIcon}>
                  <EmptyIcon />
                </div>
                <h3 className={styles.emptyTitle}>暂无帖子</h3>
                <p className={styles.emptyDesc}>成为第一个发布内容的人</p>
              </div>
            )}
          </div>
        )}

        {activeTab === "members" && (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <UserAddIcon />
            </div>
            <h3 className={styles.emptyTitle}>成员列表</h3>
            <p className={styles.emptyDesc}>这里将展示所有社群成员</p>
          </div>
        )}

        {activeTab === "about" && (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <GroupIcon />
            </div>
            <h3 className={styles.emptyTitle}>社群介绍</h3>
            <p className={styles.emptyDesc}>这里将展示社群详细信息</p>
          </div>
        )}
      </div>
    </div>
  )
}